module.exports = __webpack_public_path__ + "img/1570504332.6cb12cd4.jpg";